export const CURRENCIES = {
  usd: { country: "US", name: "US Dollar ($)" },
  gbp: { country: "GB", name: "British Pound (£)" },
  cad: { country: "CA", name: "Canadian Dollar (C$)" },
  nzd: { country: "NZ", name: "New Zealand Dollar (NZ$)" },
  aud: { country: "AU", name: "Australian Dollar (A$)" },
  eur: { country: "EU", name: "Euro (€)" },
  hkd: { country: "HK", name: "Hong Kong Dollar (HK$)" },
  sgd: { country: "SG", name: "Singapore Dollar (S$)" },
  inr: { country: "IN", name: "Indian Rupee (₹)" },
  cny: { country: "CN", name: "Chinese Yuan (¥)" },
  zar: { country: "ZA", name: "South African Rand (R)" },
  try: { country: "TR", name: "Turkish Lira (₺)" },
  php: { country: "PH", name: "Philippine Peso (₱)" },
  jpy: { country: "JP", name: "Japanese Yen (¥)" },
} as const
